import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import messages from '../messages';

const NumberOfProductsColumn = ({ categoryId }) => {
  return useSelector((state) =>
    Global.selectEntitiesReportingCategoryPropertyById(state, {
      categoryId,
      property: 'productCount',
    }),
  );
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.numberOfProductsColumn} />,
  id: 'numberOfProducts',
  sortBy: 'productCount',
  isSortable: true,
  render: NumberOfProductsColumn,
};
